module.exports = __webpack_public_path__ + "img/CLOSED.3c81852b.svg";